module.exports = __webpack_public_path__ + "img/KQ.f220b73e.jpg";